var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-input",
    {
      attrs: {
        value: _vm.value,
        label: "PIN",
        pattern: /^[0-9#*]+$/,
        "pattern-error": "Invalid PIN (only numbers, # and *)",
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _c(
        "template",
        { slot: "inlineIcon" },
        [
          _c(
            "ui-menu",
            {
              attrs: {
                icon: "fal fa-hourglass-start fa-2x",
                tooltip: "PIN delay",
              },
            },
            _vm._l(_vm.pinDelayList, function (item) {
              return _c("ui-menu-item", {
                key: item,
                attrs: {
                  icon: item === _vm.pinDelay ? "fal fa-check" : "",
                  label: item + " seconds",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("update:pinDelay", item)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }